import { projects } from '@/mocks/projects';
import { DEFAULT_OG_IMAGE } from './siteMeta';

export interface SeoData {
  title: string;
  description: string;
  keywords: string;
  path: string;
  image: string;
  robots: string;
  ogType: 'website' | 'article';
}

function truncate(text: string, max = 158): string {
  const clean = text.replace(/\s+/g, ' ').trim();
  if (clean.length <= max) return clean;
  const cut = clean.slice(0, max);
  const lastSpace = cut.lastIndexOf(' ');
  return `${cut.slice(0, lastSpace > 0 ? lastSpace : max).trim()}…`;
}

const HOME: SeoData = {
  title: 'Diseño Arquitectónico San Luis Potosí | AM ESTUDIO',
  description:
    'AM ESTUDIO es un estudio de arquitectura, diseño y construcción en San Luis Potosí. Diseño arquitectónico, diseño de interiores, render arquitectónico y cursos de render con IA.',
  keywords:
    'diseño arquitectónico San Luis Potosí, arquitectura San Luis Potosí, diseño de interiores SLP, render arquitectónico, cursos de render con IA',
  path: '/',
  image: DEFAULT_OG_IMAGE,
  robots: 'index, follow',
  ogType: 'website',
};

const PROYECTOS: SeoData = {
  title: 'Proyectos de Arquitectura en San Luis Potosí | AM ESTUDIO',
  description:
    'Portafolio de AM ESTUDIO: proyectos de diseño arquitectónico, interiores y espacios comerciales en San Luis Potosí y sus alrededores, con su proceso constructivo.',
  keywords:
    'proyectos de arquitectura San Luis Potosí, portafolio de arquitectura SLP, diseño de interiores San Luis Potosí, casas en San Luis Potosí',
  path: '/proyectos',
  image: DEFAULT_OG_IMAGE,
  robots: 'index, follow',
  ogType: 'website',
};

const NOT_FOUND: SeoData = {
  title: 'Página no encontrada | AM ESTUDIO',
  description:
    'La página que buscas no existe o fue movida. Conoce los proyectos y servicios de AM ESTUDIO en San Luis Potosí.',
  keywords: 'AM ESTUDIO, arquitectura San Luis Potosí',
  path: '/',
  image: DEFAULT_OG_IMAGE,
  robots: 'noindex, nofollow',
  ogType: 'website',
};

export function resolveSeo(pathname: string): SeoData {
  const clean =
    pathname.split('?')[0].split('#')[0].replace(/\/+$/, '') || '/';

  if (clean === '/') return HOME;
  if (clean === '/proyectos') return PROYECTOS;

  const match = clean.match(/^\/proyectos\/([^/]+)$/);
  if (match) {
    const slug = decodeURIComponent(match[1]);
    const project = projects.find((p) => p.slug === slug);
    if (project) {
      return {
        title: `${project.name} | ${project.category} en ${project.zone} — AM ESTUDIO`,
        description: truncate(
          `${project.description} Proyecto de ${project.category.toLowerCase()} en ${project.zone}, San Luis Potosí, por AM ESTUDIO.`
        ),
        keywords: `${project.name}, ${project.category.toLowerCase()} San Luis Potosí, diseño arquitectónico ${project.zone}, arquitectura San Luis Potosí, AM ESTUDIO`,
        path: `/proyectos/${project.slug}`,
        image: project.image,
        robots: 'index, follow',
        ogType: 'article',
      };
    }
  }

  return NOT_FOUND;
}